export default __webpack_public_path__ + "static/media/Admin.a91f8d58.png";